import { AcCellStatus, AcStatusType } from "components/AcStatus/AcStatus"

interface OrderCellStatusProps {
    status?: string
}

export const OrderCellStatus = ({ status }: OrderCellStatusProps) => {
    if (!status) return null
    return (
        <AcCellStatus
            theme="light"
            type={status as unknown as AcStatusType}
        />
    )
}